import type { SVGProps } from "react";
export function CloseDetailsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={2}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 12 2"
      width={12}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m10.75.75h-10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
      />
    </svg>
  );
}
